import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../app/GetProxy";
import { decrypt, handleResponseCode } from "../../app/utilities/helpers";
const cookies = new Cookies();
const proxy = GetProxy();

//PolicyNameList
export const PolicyNameListApi = createAsyncThunk(
  "post/PolicyNameListApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/getPolicyNameList`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
//Topic,SubTopic,AssessmentCount
export const TopicSubTopicAndAssessmentCountAPI = createAsyncThunk(
  "post/getTopicSubTopicAndAssessmentCountAPI",
  async (props) => {
    const { policyName, level } = props;
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/getTopicSubTopicAndAssessmentCount/${policyName}/${level}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
//createComplianceAssessment
export const CreateAssessmentAPI = createAsyncThunk(
  "post/CreateAssessmentAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/createComplianceAssessment`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getQuestionLevels = createAsyncThunk(
  "post/CreateAssessmentAPI",
  async () => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/riskAssessment/api/v1/riskAssessmentPolicy/getLevelOfQuestionList`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getUsers = createAsyncThunk("post/getUsers", async (props) => {
  const { appName } = props;
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");
  try {
    const response = await fetch(
      `${proxy}/api/v1/complianceAssessment/getUserRoleMembers/${appName}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
      }
    );
    handleResponseCode(response);

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
});
//ComplianceAssessmentDelete
export const ComplianceAssessmentDeleteAPI = createAsyncThunk(
  "post/ComplianceAssessmentDeleteAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload, userName } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/getComplianceAssessmentForDelete/${userName}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
//saveDataComplianceAssessmentQuestionDetails
export const saveDataComplianceAssessmentQuestionDetails = createAsyncThunk(
  "post/saveDataComplianceAssessmentQuestionDetails",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/saveDataComplianceAssessmentQuestionDetails`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const TriggerMailToAoForReview = createAsyncThunk(
  "post/submitForAoReviewMail",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      Payload.userName = username;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/submitForAoReviewMail`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const TriggerMailToUserForRecheckFromAO = createAsyncThunk(
  "post/requestRecheckForUserReviewMail",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    const encoded = decrypt(username);

    try {
      const { Payload } = props;
      Payload.userName = encoded;
      (Payload.complianceAssessment = Payload.assessmentId),
        delete Payload.assessmentId;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/mailRejectedByAO`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const TriggerMailToUserForRecheckFromCiso = createAsyncThunk(
  "post/requestRecheckForUserReviewMailByCiso",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    const encoded = decrypt(username);
    try {
      const { Payload } = props;
      Payload.userName = encoded;
      (Payload.complianceAssessment = Payload.assessmentId),
        delete Payload.assessmentId;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/mailRejectedByCISO`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const TriggerMailToCisoForReview = createAsyncThunk(
  "post/submitForCisoReviewMail",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/submitForCisoReviewMail`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const userSubmitForReview = createAsyncThunk(
  "post/submitForUserReview",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/submitForUserReview`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const recheckAoReview = createAsyncThunk(
  "post/recheckAoReview",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/recheckAoReview`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const recheckUserReview = createAsyncThunk(
  "post/recheckUserReview",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/recheckUserReview`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const aoSubmitForApproval = createAsyncThunk(
  "post/submitForApprovalAo",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/submitForApprovalAo`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const cisoSubmitForCompletion = createAsyncThunk(
  "post/completeAssessmentCiso",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/completeAssessmentCiso`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const deleteAttachment = createAsyncThunk(
  "post/deleteAttachments",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/deleteAttachments/${username}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const saveAttachments = createAsyncThunk(
  "post/saveAttachments",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { files, Id } = props;
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("file", file);
      });
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/complianceAssessmentSaveQuestionId/${Id}`,
        {
          method: "POST",
          headers: {
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
            "Content-Type": "multipart/form-data",
          },
          body: formData,
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const checkBlobType = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const arr = new Uint8Array(reader.result);
      let type = "";

      // Check for PNG (magic number: 89 50 4E 47)
      if (
        arr[0] === 0x89 &&
        arr[1] === 0x50 &&
        arr[2] === 0x4e &&
        arr[3] === 0x47
      ) {
        type = "image/png";
      }
      // Check for JPEG (magic number: FF D8 FF)
      else if (arr[0] === 0xff && arr[1] === 0xd8 && arr[2] === 0xff) {
        type = "image/jpeg";
      }
      // Check for PDF (magic number: 25 50 44 46)
      else if (
        arr[0] === 0x25 &&
        arr[1] === 0x50 &&
        arr[2] === 0x44 &&
        arr[3] === 0x46
      ) {
        type = "application/pdf";
      }

      resolve(type || "Unknown");
    };

    reader.onerror = (err) => reject(err);
    reader.readAsArrayBuffer(blob);
  });
};

export const downloadAttachments = createAsyncThunk(
  `post/complianceAssessmentSaveQuestionId`,
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { fileName, Id } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/downloadAttachmentQuestion`,
        {
          method: "POST",
          headers: {
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            attachmentId: Id,
            fileType: fileName,
          }),
        }
      );
      handleResponseCode(response);
      const blob = await response.blob();

      // Create a URL for the Blob
      const blobUrl = URL.createObjectURL(blob);
      // Check file type by inspecting the blob
      const fileType = await checkBlobType(blob);
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(",")[1]); // Extract Base64 string
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      return { blobUrl, fileName, base64, fileType };
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getAllListFromComplianceAssessment = createAsyncThunk(
  "post/getAllListFromComplianceAssessment",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/getAllListFromComplianceAssessment`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
//Download
export const DownloadList = createAsyncThunk(
  "post/DownloadList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/generatePdf`,
        {
          method: "POST",
          headers: {
            Accept: "application/octet-stream",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);
      const data = await response.blob();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getAllListFromComplianceAssessmentCount = createAsyncThunk(
  "post/getAllListFromComplianceAssessmentCount",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { Payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/complianceAssessment/getAllListFromSubTopicAndTopicCount`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(Payload),
        }
      );
      handleResponseCode(response);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

const ComplianceAssessment = createSlice({
  name: "ComplianceAssessment",
  initialState: {
    PolicyLoading: false,
    PolicyList: [],
    TopicSubTopicAndAssessmentCountLoading: false,
    TopicSubTopicAndAssessmentCountData: [],
    CreateAssessmentLoading: false,
    CreateAssessmentData: [],
    ComplianceAssessmentDeleteLoading: false,
    ComplianceAssessmentDeleteData: {},
    errorDelete: "",
    DownloadListloading: false,
    DownloadListDetails: [],
    submitActionResponse: {},
    submitLoading: false,
    attachmentLoading: false,
    attachmentData: [],
    downloadAttachmentLoading: false,
    attachmentPreview: [],
    questionsLoading: true,
    questionsListFromComplianceAssessment: [],
    questionListFromComplianceAssessmentCount: [],
    complianceInitialValues: null,
  },

  reducers: {
    setComplianceInitialValuesStore: (state, action) => {
      state.complianceInitialValues = {
        ...state.complianceInitialValues,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      //PolicyNameList
      .addCase(PolicyNameListApi.pending, (state, action) => {
        state.PolicyLoading = true;
      })
      .addCase(PolicyNameListApi.fulfilled, (state, action) => {
        state.PolicyList = action.payload;
        state.PolicyLoading = false;
      })
      .addCase(PolicyNameListApi.rejected, (state, action) => {
        state.PolicyLoading = false;
        state.PolicyList = [];
      })

      //Topic,SubTopic,AssessmentCount
      .addCase(TopicSubTopicAndAssessmentCountAPI.pending, (state, action) => {
        state.TopicSubTopicAndAssessmentCountLoading = true;
      })
      .addCase(
        TopicSubTopicAndAssessmentCountAPI.fulfilled,
        (state, action) => {
          state.TopicSubTopicAndAssessmentCountData = action.payload;
          state.TopicSubTopicAndAssessmentCountLoading = false;
        }
      )
      .addCase(TopicSubTopicAndAssessmentCountAPI.rejected, (state, action) => {
        state.TopicSubTopicAndAssessmentCountLoading = false;
        state.TopicSubTopicAndAssessmentCountData = [];
      })
      //CreateAssessment
      .addCase(CreateAssessmentAPI.pending, (state, action) => {
        state.CreateAssessmentLoading = true;
      })
      .addCase(CreateAssessmentAPI.fulfilled, (state, action) => {
        state.CreateAssessmentData = action.payload;
        state.CreateAssessmentLoading = false;
      })
      .addCase(CreateAssessmentAPI.rejected, (state, action) => {
        state.CreateAssessmentLoading = false;
        state.CreateAssessmentData = [];
      })
      //trigger mail to AO for review
      .addCase(TriggerMailToAoForReview.pending, (state, action) => { })
      .addCase(TriggerMailToAoForReview.fulfilled, (state, action) => { })
      .addCase(TriggerMailToAoForReview.rejected, (state, action) => { })

      //trigger mail to CISO for review
      .addCase(TriggerMailToCisoForReview.pending, (state, action) => { })
      .addCase(TriggerMailToCisoForReview.fulfilled, (state, action) => { })
      .addCase(TriggerMailToCisoForReview.rejected, (state, action) => { })
      //submit for review
      .addCase(userSubmitForReview.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(userSubmitForReview.fulfilled, (state, action) => {
        state.submitActionResponse = action.payload;
        state.submitLoading = false;
      })
      .addCase(userSubmitForReview.rejected, (state, action) => {
        state.submitLoading = false;
        state.submitActionResponse = action.payload;
      })
      //recheckAoReview
      .addCase(recheckAoReview.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(recheckAoReview.fulfilled, (state, action) => {
        state.submitActionResponse = action.payload;
        state.submitLoading = false;
      })
      .addCase(recheckAoReview.rejected, (state, action) => {
        state.submitLoading = false;
        state.submitActionResponse = action.payload;
      })
      //recheckUserReview
      .addCase(recheckUserReview.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(recheckUserReview.fulfilled, (state, action) => {
        state.submitActionResponse = action.payload;
        state.submitLoading = false;
      })
      .addCase(recheckUserReview.rejected, (state, action) => {
        state.submitLoading = false;
        state.submitActionResponse = action.payload;
      })
      //ao submit for approval
      .addCase(aoSubmitForApproval.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(aoSubmitForApproval.fulfilled, (state, action) => {
        state.submitActionResponse = action.payload;
        state.submitLoading = false;
      })
      .addCase(aoSubmitForApproval.rejected, (state, action) => {
        state.submitLoading = false;
        state.submitActionResponse = action.payload;
      })
      //ciso submit for approval
      .addCase(cisoSubmitForCompletion.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(cisoSubmitForCompletion.fulfilled, (state, action) => {
        state.submitActionResponse = action.payload;
        state.submitLoading = false;
      })
      .addCase(cisoSubmitForCompletion.rejected, (state, action) => {
        state.submitLoading = false;
        state.submitActionResponse = action.payload;
      })
      //ComplianceAssessmentDelete
      .addCase(ComplianceAssessmentDeleteAPI.pending, (state, action) => {
        state.ComplianceAssessmentDeleteLoading = true;
      })
      .addCase(ComplianceAssessmentDeleteAPI.fulfilled, (state, action) => {
        state.ComplianceAssessmentDeleteData = action.payload;
        state.ComplianceAssessmentDeleteLoading = false;
      })
      .addCase(ComplianceAssessmentDeleteAPI.rejected, (state, action) => {
        state.ComplianceAssessmentDeleteLoading = false;
        state.errorDelete = "Something went wrong";
      })
      //saveDataComplianceAssessmentQuestionDetails
      .addCase(
        saveDataComplianceAssessmentQuestionDetails.pending,
        (state, action) => {
          state.saveDataLoading = true;
        }
      )
      .addCase(
        saveDataComplianceAssessmentQuestionDetails.fulfilled,
        (state, action) => {
          state.saveData = action.payload;
          state.saveDataLoading = false;
        }
      )
      .addCase(
        saveDataComplianceAssessmentQuestionDetails.rejected,
        (state, action) => {
          state.saveDataLoading = false;
          state.saveData = [];
        }
      )
      //ListFromComplianceAssessment
      .addCase(getAllListFromComplianceAssessment.pending, (state, action) => {
        state.questionsLoading = true;
      })
      .addCase(
        getAllListFromComplianceAssessment.fulfilled,
        (state, action) => {
          state.questionsListFromComplianceAssessment = action.payload;
          state.questionsLoading = false;
        }
      )
      .addCase(getAllListFromComplianceAssessment.rejected, (state, action) => {
        state.questionsLoading = false;
        state.questionsListFromComplianceAssessment = [];
      })
      .addCase(
        getAllListFromComplianceAssessmentCount.pending,
        (state, action) => { }
      )
      .addCase(
        getAllListFromComplianceAssessmentCount.fulfilled,
        (state, action) => {
          state.questionListFromComplianceAssessmentCount = action.payload;
        }
      )
      .addCase(
        getAllListFromComplianceAssessmentCount.rejected,
        (state, action) => {
          state.questionListFromComplianceAssessmentCount = 0;
        }
      )
      //saveAttachments
      .addCase(saveAttachments.pending, (state, action) => {
        state.attachmentLoading = true;
      })
      .addCase(saveAttachments.fulfilled, (state, action) => {
        state.attachmentData = action.payload;
        state.attachmentLoading = false;
      })
      .addCase(saveAttachments.rejected, (state, action) => {
        state.attachmentLoading = false;
      })
      //Download
      .addCase(DownloadList.pending, (state, action) => {
        state.DownloadListloading = true;
      })
      .addCase(DownloadList.fulfilled, (state, action) => {
        state.DownloadListDetails = action.payload;
        state.DownloadListloading = false;
      })
      .addCase(DownloadList.rejected, (state, action) => {
        state.DownloadListloading = false;
      })
      //
      .addCase(downloadAttachments.pending, (state, action) => {
        state.downloadAttachmentLoading = true;
      })
      .addCase(downloadAttachments.fulfilled, (state, action) => {
        state.downloadAttachmentLoading = false;
        state.attachmentPreview = action.payload;
      })
      .addCase(downloadAttachments.rejected, (state, action) => {
        state.downloadAttachmentLoading = false;
      });
  },
});

export const { setComplianceInitialValuesStore } = ComplianceAssessment.actions;
export default ComplianceAssessment.reducer;
